<script context="module">
    import { writable } from "svelte/store";
    export const loading = writable(false);
</script>

<script>
    import LinearProgress from "@smui/linear-progress";
</script>

<style lang="scss">
    .hide {
        visibility: hidden;
        opacity: 0;
    }
</style>

<div class:hide={!$loading}>
    <LinearProgress indeterminate />
</div>
